import React from 'react'
import AdminProductDetails from '../features/admin/components/AdminProductDetails'
import Navbar from '../features/navbar/Navbar'

export default function AdminProductDetailsPage() {
  return (
    <>
    <Navbar>
    <AdminProductDetails></AdminProductDetails>
    </Navbar>
    </>
  )
}
